module.exports = __webpack_public_path__ + "img/home-kurs-3.3100082c.png";